import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/link';
import NavigationBetweenArticlesLink from './navigation-between-articles-link';
import navigationBetweenArticlesLinkTypes from './navigation-between-articles-link-types';

const NavigationBetweenArticles = ({
  prevLink,
  nextLink,
  lang = {
    navigationBetweenArticlesAriaLabel: 'Navigering mellom artikler',
  },
}) => {
  return prevLink || nextLink ? (
    <div className="navigation-between-articles">
      <nav
        className="navigation-between-articles__container"
        aria-label={lang.navigationBetweenArticlesAriaLabel}
      >
        <ul className="navigation-between-articles__list">
          {prevLink && (
            <li className="navigation-between-articles__item navigation-between-articles__item_prev">
              <NavigationBetweenArticlesLink
                {...prevLink}
                type={navigationBetweenArticlesLinkTypes.prev}
              />
            </li>
          )}
          {nextLink && (
            <li className="navigation-between-articles__item navigation-between-articles__item_next">
              <NavigationBetweenArticlesLink
                {...nextLink}
                type={navigationBetweenArticlesLinkTypes.next}
              />
            </li>
          )}
        </ul>
      </nav>
    </div>
  ) : null;
};

NavigationBetweenArticles.propTypes = {
  prevLink: PropTypes.exact(Link.propTypes),
  nextLink: PropTypes.exact(Link.propTypes),
  lang: PropTypes.shape({
    navigationBetweenArticlesAriaLabel: PropTypes.string.isRequired,
  }).isRequired,
};

export default NavigationBetweenArticles;
